import { Box, TextField, Typography } from "@mui/material";
import { useGetOrderByIdQuery } from "app/api/orders";
import LoadingDisplay from "components/LoadingDisplay";
import SimpleDialog from "components/SimpleDialog";
import { useDebounce } from "hooks/useDebounce";
import { useState } from "react";

type AddressFromOrderDialogProps = { onClose: () => void; onConfirm: (address: string) => void };

const AddressFromOrderDialog: React.FC<AddressFromOrderDialogProps> = (props) => {
  const { onClose, onConfirm } = props;

  const [orderNumber, setOrderNumber] = useState("");
  const debouncedOrderNumber = useDebounce(orderNumber, { delayMs: 500 });
  const { data: orderData, isFetching: isOrderLoading } =
    useGetOrderByIdQuery(debouncedOrderNumber);

  return (
    <SimpleDialog
      title="Hämta adress från order"
      onClose={onClose}
      onConfirm={() => {
        if (orderData)
          onConfirm(`${orderData.address}, ${orderData.postnr} ${orderData.postaddress}` || "");
        onClose();
      }}
      confirmProps={{ disabled: !orderData }}
    >
      <TextField
        label="Ordernummer"
        variant="filled"
        fullWidth
        autoFocus
        value={orderNumber}
        onChange={(e) => setOrderNumber(e.target.value)}
        sx={{ mb: 2 }}
      />

      {isOrderLoading && <LoadingDisplay message="Hämtar order..." />}

      {orderData && (
        <Box>
          <Typography fontWeight="bold">{orderData.companyName}</Typography>
          <Typography>
            {orderData.address}, {orderData.postnr} {orderData.postaddress}
          </Typography>
        </Box>
      )}
    </SimpleDialog>
  );
};

export default AddressFromOrderDialog;
